module.exports = __webpack_public_path__ + "img/pathology-obstruction.29a608c9.png";